import React from "react";

const Title = ({ text, image, center = false, iconCenter = false }) => {
  return (
    <h1
      className={`text-5xl max-w-max relative ${
        center ? "text-center mx-auto" : ""
      }`}
    >
      {text}
      <img
        src={image}
        className={`${
          iconCenter ? "-translate-x-1/2 left-1/2" : " -translate-x-1/4"
        } absolute top-1/2 -translate-y-1/2 w-[100px] -translate-x-1/4`}
        alt=""
      />
    </h1>
  );
};

export default Title;
